import { apiBaseUrl } from '../config/apiConfig';

const staffApiUrl = `${apiBaseUrl}/api/staffs`;
const staffWorkingNotificationApiUrl = `${apiBaseUrl}/api/staff-notifications`;

// use this for production
//const staffApiUrl = `https://plus-appointment.com/api/staff`;
// Utility function to get token and handle missing authentication
const getToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('User not authenticated');
  }
  return token;
};

// Utility function to handle API responses
const handleApiResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || 'API request failed');
  }
  return data;
};

// Function to build API URL


// API client function for fetching staff
export const fetchStaff = async (businessId) => {
  const response = await fetch(`${staffApiUrl}/businesses/${businessId}`, {
    method: 'GET',
  });
  const data = await handleApiResponse(response);
  if (Array.isArray(data)) {
    return data;
  } else if (data.$values) {
    return data.$values;
  } else {
    throw new Error('Unexpected data format');
  }
};

// API client function for adding a new staff member
export const addStaff = async (businessId, staffDetails) => {
  const token = getToken();
  const response = await fetch(`${staffApiUrl}/businesses/${businessId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(staffDetails)
  });
  return await handleApiResponse(response);
};

// API client function for deleting a staff member
export const deleteStaff = async (businessId, staffId) => {
  const token = getToken();
  const response = await fetch(`${staffApiUrl}/businesses/${businessId}/staffs/${staffId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });
  return await handleApiResponse(response);
};

// API client function for updating a staff member
export const updateStaff = async (businessId, staffId, staffDetails) => {
  const token = getToken();
  const response = await fetch(`${staffApiUrl}/businesses/${businessId}/staffs/${staffId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(staffDetails)
  });
  return await handleApiResponse(response);
};


export const loginStaff = async (loginDetails) => {
  const response = await fetch(`${staffApiUrl}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      
    },
    body: JSON.stringify(loginDetails),
    credentials: 'include'
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const refreshToken = async () => {
  const token = localStorage.getItem('token');
  const refreshTokenValue = localStorage.getItem('refreshToken');
  if (!token || !refreshTokenValue) {
    throw new Error('No token or refresh token found');
  }

  const response = await fetch(`${staffApiUrl}/refresh`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, refreshToken: refreshTokenValue }),
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to refresh token');
  }

  const data = await response.json();
  return data;
};

// API client function for fetching staff working notification
export const fetchStaffWorkSessionNotification = async (staffId) => {
  const token = getToken();
  const response = await fetch(`${staffWorkingNotificationApiUrl}/${staffId}/all`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  });
  const data = await handleApiResponse(response);
  if (Array.isArray(data)) {
    return data;
  } else if (data.$values) {
    return data.$values;
  } else {
    throw new Error('Unexpected data format');
  }
};

export const markStaffWorkSessionNotificationAsSeen = async (staffId, notificationId) => {
  const token = getToken();
  const res = await fetch(`${staffWorkingNotificationApiUrl}/${staffId}/${notificationId}/seen`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    // Try to decode JSON error, otherwise use status text
    let msg = `Failed to mark notification as seen (${res.status})`;
    try {
      const data = await res.json();
      if (data?.message) msg = data.message;
    } catch {
      // ignore parse errors
    }
    throw new Error(msg);
  }

  return true; // success, no response body
};